import useCategories from 'hooks/useCategories';
import React from 'react';
import CategoriesList from '@rahtab/system/lib/screens/CategoriesList';

const OrderCategories = () => {
  const { called, loading, data, refetch } = useCategories();
  return (
    <CategoriesList
      screenTitle="سفارش‌گذاری"
      loading={loading}
      listData={data.map((category) => {
        return {
          id: category.id,
          image: category.imageUrl,
          name: category.name,
          statusText: category.statusText,
          status: category.status,
        };
      })}
      refreshing={called && loading}
      onRefresh={refetch}
      screenName={'CategoryMerchandises'}
    />
  );
};
export default OrderCategories;
